/**
 * Normalizes image URL to use HTTPS protocol.
 * This is required for Telegram WebApp which runs on HTTPS,
 * and browsers block "mixed content" (HTTP resources on HTTPS pages).
 * 
 * @param url - The image URL to normalize
 * @returns The normalized URL with HTTPS protocol, or empty string if URL is falsy
 */
export const normalizeImageUrl = (url: string | null | undefined): string => {
  if (!url) return '';
  
  // Replace HTTP with HTTPS to avoid mixed content issues in Telegram WebApp
  if (url.startsWith('http://')) {
    return url.replace('http://', 'https://');
  }
  
  return url;
};
